import { isNullOrEmpty } from '../config/ENV';
export function formatPhoneNumber(phoneNumber){
    if (!isNullOrEmpty(phoneNumber)&&phoneNumber.length > 0) {
      var countryCode = phoneNumber.slice(0, 1);
      var number = phoneNumber.slice(
        1,
        phoneNumber.length
      );
      var requiredNumberFormat =
       "(" + number.slice(0, 3) + ")" +" " + number.slice(3, 6) 
       if(number.length>6){
       requiredNumberFormat+= "-" + number.slice(6);
       }
      if (!isNullOrEmpty(countryCode)) {
        return " +1 " +" " + requiredNumberFormat;
      }
      return  requiredNumberFormat;
    }
    return;
  };